import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDateTime',
  standalone: true,
})
export class CustomDateTimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: string | string[] | number | undefined, format: 'date' | 'time' | 'both'): string | undefined {
    // Check if value is a string and not empty
    if (typeof value === 'string' && value) {
      const date = new Date(value);
      switch (format) {
        case 'date':
          return this.datePipe.transform(date, 'dd MMMM, yyyy') || '';
        case 'time':
          return this.datePipe.transform(date, 'hh:mm:ss a') || '';
        case 'both':
          return `${this.datePipe.transform(date, 'dd MMMM, yyyy')}, ${this.datePipe.transform(date, 'hh:mm:ss a')}`;
        default:
          return value;
      }
    }
    return undefined; // Return undefined if input is not a valid string
  }
}
